import { AppointmentStatusTag } from 'src/pages/_components/AppointmentStatusTag/AppointmentStatusTag';
import { Appointment } from '../../../../gql/graphql';
import { Accordion } from '../../../../ui/components/Accordion/Accordion';
import { Grid } from '../../../../ui/components/PageBuilder/Grid/Grid';
import { AppointmentCommentBox } from '../AppointmentCommentBox/AppointmentCommentBox';
import styles from './AppointmentFullInfoCard.module.scss';

interface AppointmentFullInfoCardI {
  appointment: Appointment;
}

export const AppointmentFullInfoCard = ({
  appointment,
}: AppointmentFullInfoCardI) => {
  const appointmentDate = new Date(Number(appointment.dayOfAppointment));
  const formattedDate = appointmentDate.toISOString().split('T')[0];

  return (
    <div className={styles.card}>
      <Grid gridColumns={3} classname={styles.grid}>
        <p className={styles.info}>
          <strong>Cliente:</strong> {appointment.Client?.name || 'N/A'}{' '}
          {appointment.Client?.lastName || ''}
        </p>
        <p className={styles.info}>
          <strong>Servicio:</strong> {appointment.service?.name || 'N/A'}
        </p>
        <p className={styles.info}>
          <strong>Fecha:</strong> {formattedDate}
        </p>
        <p className={styles.info}>
          <strong>Hora:</strong> {appointment.hourOfAppointment || 'N/A'}
        </p>
        <p className={styles.info}>
          <strong>Estado:</strong>
          <AppointmentStatusTag status={appointment?.status} />
        </p>
      </Grid>
      <Accordion title="Historial de comentarios de la cita">
        <AppointmentCommentBox appointment={appointment} />
      </Accordion>
    </div>
  );
};
